// Add event listener to variant swatch elements
document.querySelectorAll('.js-option').forEach(function(element) {

    // Initial page load check
    if(element.checked){
        var selectedVariant = element.dataset;
        var selectedSku = selectedVariant.variantsku; // Assuming SKU is stored in 'sku' attribute of variant data
        var currentZoneNumber = getZoneCookie();
        var currentZipcode = getZipCodeCookie();
        const endpoint = getShippingMessageSetting("shippingMessageEndpoint");
      
        if(!currentZoneNumber) return;
      
        // Construct API request
        var apiUrl = endpoint + "/" + selectedSku + "/" + currentZoneNumber;

        // Make API call
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(function(response) {
            // Handle API response          
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Failed to fetch data from API');
            }
        })
        .then(function(data) {
            // Handle API response data
            var destinationElementContainer = document.getElementById(getShippingMessageSetting("message_container_id"));
            var destinationElement = document.getElementById(getShippingMessageSetting("message_span_id"));
            var destinationZipCode = document.getElementById("delivery-zipcode");
            var destinationZipCodeContainer = document.getElementById("delivery-zipcode-container");
          
            if(destinationElement){
              if(data.estimatedShippingWindow && data.estimatedShippingWindow != ""){
                destinationElement.innerText = data.estimatedShippingWindow;
                destinationZipCode.innerText = 'Delivering to ' + currentZipcode;
                destinationElementContainer.classList.remove('hide');  
                destinationZipCodeContainer.classList.remove('hide');  
              }else{
                destinationElement.innerText = '';
                destinationZipCode.innerText = '';
                destinationElementContainer.classList.add('hide');
                destinationZipCodeContainer.classList.add('hide'); 
              }              
            }
        })
        .catch(function(error) {
            console.error('Error:', error);
        });
    }
  
    element.addEventListener('click', function(event) {
        // Retrieve selected variant information
        var selectedVariant = event.currentTarget.dataset;
        var selectedSku = selectedVariant.variantsku; // Assuming SKU is stored in 'sku' attribute of variant data
        var currentZoneNumber = getZoneCookie();
        var currentZipcode = getZipCodeCookie();
        const endpoint = getShippingMessageSetting("shippingMessageEndpoint");
      
        if(!currentZoneNumber) return;
      
        // Construct API request
        var apiUrl = endpoint + "/" + selectedSku + "/" + currentZoneNumber;

        // Make API call
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then(function(response) {
            // Handle API response          
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Failed to fetch data from API');
            }
        })
        .then(function(data) {
            // Handle API response data
            var destinationElementContainer = document.getElementById(getShippingMessageSetting("message_container_id"));
            var destinationElement = document.getElementById(getShippingMessageSetting("message_span_id"));
            var destinationZipCode = document.getElementById("delivery-zipcode");
            var destinationZipCodeContainer = document.getElementById("delivery-zipcode-container");
          
            if(destinationElement){
              if(data.estimatedShippingWindow && data.estimatedShippingWindow != ""){
                destinationElement.innerText = data.estimatedShippingWindow;
                destinationZipCode.innerText = 'Delivering to ' + currentZipcode;
                destinationElementContainer.classList.remove('hide');  
                destinationZipCodeContainer.classList.remove('hide');  
              }else{
                destinationElement.innerText = '';
                destinationZipCode.innerText = '';
                destinationElementContainer.classList.add('hide');
                destinationZipCodeContainer.classList.add('hide');  
              }              
            }
        })
        .catch(function(error) {
            console.error('Error:', error);
        });
    });
});

// Define a function to retrieve the setting
function getShippingMessageSetting(settingId) {
    if (window.shippingMessageThemeSettings && settingId in window.shippingMessageThemeSettings) {
        return window.shippingMessageThemeSettings[settingId];
    } else {
        return null; // Return null if the property doesn't exist
    }
}

// Function to retrieve cookie value by name
function getZoneCookie() {
    const name = "growing_zone=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i <cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}

function getZipCodeCookie() {
    const name = "growing_zipcode=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i <cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}